import CryptoJS from "crypto-js";
import config from "../config";

const SECRET_KEY = config.SECRET_KEY || "my_super_secret_key";

/**
 * Encrypt AWS URL
 */
export const encryptURL = (url) => {
  // Generate random 16-byte IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Derive 256-bit key (same as crypto.createHash('sha256'))
  const key = CryptoJS.SHA256(SECRET_KEY);

  const encrypted = CryptoJS.AES.encrypt(url, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  // Combine IV + encrypted data
  const result =
    CryptoJS.enc.Base64.stringify(iv) +
    ":" +
    encrypted.ciphertext.toString(CryptoJS.enc.Base64);

  return encodeURIComponent(result);
};

/**
 * Decrypt AWS URL
 */
export const decryptURL = (encryptedUrl) => {
  const decoded = decodeURIComponent(encryptedUrl);
  const [ivBase64, encryptedBase64] = decoded.split(":");

  const iv = CryptoJS.enc.Base64.parse(ivBase64);
  const encrypted = CryptoJS.enc.Base64.parse(encryptedBase64);
  const key = CryptoJS.SHA256(SECRET_KEY);

  const decrypted = CryptoJS.AES.decrypt({ ciphertext: encrypted }, key, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });

  return decrypted.toString(CryptoJS.enc.Utf8);
};
